import React from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { organizationUsersById } from "reduxSlices/organizationUsersSlice"
import { ProfileIcon } from "shared/icons"

const TaskUserProfileIconList = ({ userIds }) => {
  const users = useSelector(organizationUsersById(userIds), isEqual)

  return (
    <div className="flex flex-wrap gap-1">
      {
        users.map((user) => (
          <ProfileIcon
            key={user.id}
            user={user}
            className="flex items-center justify-center h-6 w-6"
            includeScreenReaderText
          />
        ))
      }
    </div>
  )
}

TaskUserProfileIconList.propTypes = {
  userIds: types.arrayOf(types.number).isRequired,
}

export default TaskUserProfileIconList
